import React from "react";
import moment from "moment";

import Title03Text from "../../../../../components/components-text/title-03-text";
import MainTable from "../../../../../components/main-table";
import { SimpleButton } from "../../../../../components/buttons";
import { images } from "../../../../../assets";
import { QuestionnairesStatusProps } from "./questionnaire-status-dto";

const QuestionnaireStatus = ({ hiring, getHiring }: QuestionnairesStatusProps) => {
  const getRows = () => {
    if ("questionnairesStatus" in hiring && hiring.questionnairesStatus) {
      const rows = hiring.questionnairesStatus.map((item) => {
        const updatedAt =
          item.updatedAt && item.updatedAt.includes("T")
            ? moment(item.updatedAt).format("DD/MM/YYYY hh:mm:ss")
            : item.updatedAt;

        return {
          insured: { text: item.insuredName !== "undefined" ? item.insuredName : "", key: "body" },
          status: { text: item.status || "", key: "body" },
          date: { text: updatedAt || "", key: "body" },
        };
      });

      return rows;
    }
    return [];
  };

  return (
    <div className="detail-pendant-hiring-item">
      <div className="detail-pendant-hiring-item-title">
        <Title03Text>
          <p>Estado de Cuestionario</p>
        </Title03Text>
      </div>
      <div className="detail-pendant-hiring-item-content">
        {hiring.questionnairesStatus && (
          <div className="detail-pendant-hiring-item-content-table">
            <MainTable
              className="table noZebra"
              columns={[
                { text: "Asegurado" },
                { text: "Estado Cuestionario" },
                { text: "Fecha Alta" },
              ]}
              rows={getRows()}
              keysRow={["insured", "status", "date"]}
            />
          </div>
        )}
        {hiring.questionnairesStatusError && (
          <div className="error-msg">
            <p>
              Error al recuperar el estado de los cuestionarios:{" "}
              {hiring.questionnairesStatusError.errorMessage}. Por favor, reintente
            </p>
              <SimpleButton
                text="Reintentar"
                icon={images.IconRetry}
                alt="icono reintentar"
                onClick={getHiring}
              />
          </div>
        )}
      </div>
    </div>
  );
};

export default QuestionnaireStatus;
